import { ASSETS } from "./assets-data";

export const SERVICES_PAGE_DATA = {
    en: {
        servicesPage: {
            introTitle: "Built for Southwest Florida Waters",
            introSubtitle: "We don't just build docks — we engineer waterfront structures designed to withstand the salt air, tides, and storms of Cape Coral and SWFL. Every project is permitted, inspected, and built to last.",
            faqTitle: "Common Questions",

            hero: {
                title: "Marine Construction Services in Cape Coral, FL",
                tagline: "Tropical Marine Construction",
                description: "Custom dock construction, boat lift sales & installation, repair, and maintenance services for Cape Coral and all of Southwest Florida.",
                subDescription: "Serving Lee, Charlotte & Collier Counties | License #CBC1260600",
                heroMedia:ASSETS.WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_4
            },

            process: {
                title: "The Tropical Marine Standard",
                content: "Every project follows a proven, permit-compliant process built around Southwest Florida's unique marine environment and local code requirements.",
                steps: [
                    {
                        title: "Site Assessment",
                        description: "We visit your waterfront property to assess water depth, tidal range, canal width, and existing structure conditions before recommending any solution."
                    },
                    {
                        title: "Custom Design",
                        description: "We design a dock, boat lift, or marine structure tailored to your boat size, usage, and property layout — no one-size-fits-all approach."
                    },
                    {
                        title: "Permitted Construction",
                        description: "100% code-compliant builds. We pull all required Lee, Charlotte, or Collier County permits, handle inspections, and ensure full insurance compliance."
                    },
                    {
                        title: "Final Inspection",
                        description: "Every completed structure is walk-tested, hardware-checked, and signed off before we hand over the keys to your new waterfront."
                    }
                ]
            },

            stories: {
                title: "Cape Coral's Waterfront Experts",
                content: "Our clients enjoy stronger, safer docks and boat lifts that hold up against Florida's weather season after season. We measure our success by how long your structure lasts — and how much you enjoy it.",
                image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551515731.jpg"
            },

            faqList: [
                {
                    question: "Do I need a permit for a new dock or boat lift in Cape Coral?",
                    answer: "Yes. All dock construction and boat lift installations in Cape Coral require permits from Lee County and the City of Cape Coral. We handle the entire permitting process for you."
                },
                {
                    question: "What types of docks do you build?",
                    answer: "We build composite, wood, and aluminum docks — including fixed docks, floating docks, and seawall-mounted structures. Every design is custom to your property and waterway."
                },
                {
                    question: "How long does a typical dock construction project take?",
                    answer: "Most dock projects take 2–4 weeks from permit approval to completion. Permitting itself can take 2–6 weeks depending on the county and scope of work."
                },
                {
                    question: "Can you repair an existing dock or boat lift?",
                    answer: "Yes. We repair all dock types and boat lift brands — including hydraulic, electric, and PWC lifts. We assess damage, replace worn components, and restore full function."
                },
                {
                    question: "What areas do you serve?",
                    answer: "We primarily serve Cape Coral, Fort Myers, Punta Gorda, Port Charlotte, and surrounding Lee, Charlotte, and Collier County communities."
                }
            ]
        }
    },
    he: {
        servicesPage: {
            introTitle: "Built for Southwest Florida Waters",
            introSubtitle: "We don't just build docks — we engineer waterfront structures designed to withstand the salt air, tides, and storms of Cape Coral and SWFL. Every project is permitted, inspected, and built to last.",
            faqTitle: "Common Questions",

            hero: {
                title: "Marine Construction Services in Cape Coral, FL",
                tagline: "Tropical Marine Construction",
                description: "Custom dock construction, boat lift sales & installation, repair, and maintenance services for Cape Coral and all of Southwest Florida.",
                subDescription: "Serving Lee, Charlotte & Collier Counties | License #CBC1260600",
                heroMedia: "/placeholder.svg"
            },

            process: {
                title: "The Tropical Marine Standard",
                content: "Every project follows a proven, permit-compliant process built around Southwest Florida's unique marine environment and local code requirements.",
                steps: [
                    {
                        title: "Site Assessment",
                        description: "We visit your waterfront property to assess water depth, tidal range, canal width, and existing structure conditions before recommending any solution."
                    },
                    {
                        title: "Custom Design",
                        description: "We design a dock, boat lift, or marine structure tailored to your boat size, usage, and property layout — no one-size-fits-all approach."
                    },
                    {
                        title: "Permitted Construction",
                        description: "100% code-compliant builds. We pull all required Lee, Charlotte, or Collier County permits, handle inspections, and ensure full insurance compliance."
                    },
                    {
                        title: "Final Inspection",
                        description: "Every completed structure is walk-tested, hardware-checked, and signed off before we hand over the keys to your new waterfront."
                    }
                ]
            },

            stories: {
                title: "Cape Coral's Waterfront Experts",
                content: "Our clients enjoy stronger, safer docks and boat lifts that hold up against Florida's weather season after season. We measure our success by how long your structure lasts — and how much you enjoy it.",
                image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551515731.jpg"
            },

            faqList: [
                {
                    question: "Do I need a permit for a new dock or boat lift in Cape Coral?",
                    answer: "Yes. All dock construction and boat lift installations in Cape Coral require permits from Lee County and the City of Cape Coral. We handle the entire permitting process for you."
                },
                {
                    question: "What types of docks do you build?",
                    answer: "We build composite, wood, and aluminum docks — including fixed docks, floating docks, and seawall-mounted structures. Every design is custom to your property and waterway."
                },
                {
                    question: "How long does a typical dock construction project take?",
                    answer: "Most dock projects take 2–4 weeks from permit approval to completion. Permitting itself can take 2–6 weeks depending on the county and scope of work."
                },
                {
                    question: "Can you repair an existing dock or boat lift?",
                    answer: "Yes. We repair all dock types and boat lift brands — including hydraulic, electric, and PWC lifts. We assess damage, replace worn components, and restore full function."
                },
                {
                    question: "What areas do you serve?",
                    answer: "We primarily serve Cape Coral, Fort Myers, Punta Gorda, Port Charlotte, and surrounding Lee, Charlotte, and Collier County communities."
                }
            ]
        }
    }
};

export const getServicesPageData = (lang = 'en') => {
    return SERVICES_PAGE_DATA[lang] || SERVICES_PAGE_DATA['en'];
};
